import { GeneralModel } from "./general.model";

export class PricingType extends GeneralModel {

}